import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { RouterProvider } from './app/router';
import { SessionProvider } from './app/session';
import { ToastProvider } from './components/overlay';
import './theme/theme.css';

async function start() {
  // Literal check so production builds (VITE_API_MODE=live) drop the demo API entirely.
  if (import.meta.env.VITE_API_MODE !== 'live') {
    const { startMock } = await import('./mock');
    startMock();
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <RouterProvider>
        <ToastProvider>
          <SessionProvider>
            <App />
          </SessionProvider>
        </ToastProvider>
      </RouterProvider>
    </StrictMode>,
  );
}

void start();
